import * as React from 'react';
import { Button } from '@lendi-ui/button';

import { INVITATION_STATUS } from '@funnels/constants';

import { StringDisplay } from '../../Fields';
import { StringReadOnlyViewProps } from '../types';
import { AccompanimentContainer } from './index.style';

interface InviteStatusReadOnlyViewProps extends StringReadOnlyViewProps {
  after?: React.ReactNode;
}

export const InviteStatusReadOnlyView = (props: InviteStatusReadOnlyViewProps) => (
  <StringDisplay title={'Invite status'} after={props.after} value={props.value} textSize={'sm'} />
);

interface InviteStatusReadOnlyViewAccompanimentProps {
  status?: INVITATION_STATUS;
  canInvite?: boolean;
  cancelInvite: () => void;
  sendInvite: () => void;
}

export const InviteStatusReadOnlyViewAccompaniment = (props: InviteStatusReadOnlyViewAccompanimentProps) => {
  const { status, canInvite = true, cancelInvite, sendInvite } = props;
  switch (status) {
    case INVITATION_STATUS.ACCEPTED:
      return null;
    case INVITATION_STATUS.PENDING:
      return (
        <AccompanimentContainer>
          <Button type={'button'} variant={'secondary'} size={'xs'} onClick={cancelInvite}>
            Revoke Invite
          </Button>
        </AccompanimentContainer>
      );
    case INVITATION_STATUS.EXPIRED:
    case INVITATION_STATUS.CANCELLED:
      return (
        <AccompanimentContainer>
          <Button type={'button'} variant={'secondary'} size={'xs'} onClick={sendInvite}>
            Resend Invite
          </Button>
        </AccompanimentContainer>
      );
    default:
      return (
        <AccompanimentContainer>
          <Button isDisabled={!canInvite} type={'button'} variant={'secondary'} size={'xs'} onClick={sendInvite}>
            Send Invite
          </Button>
        </AccompanimentContainer>
      );
  }
};
